import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum ContractStatus {
  Registered = 1,
  Active = 2,
  Suspended = 3,
  Finalized = 4,
  Canceled = 5,
  Denied = 6,
  CanceledByDefaulter = 7,
  CanceledByChargeBack = 8,
  RenewFailed = 9,
  RenewInProgress = 10,
  DefaulterExternal = 11,
}
EnumDescriptions.setDescriptions(ContractStatus, [
  i18n.t('enums.registered'),
  i18n.t('enums.active'),
  i18n.t('enums.suspended'),
  i18n.t('enums.finalized'),
  i18n.t('enums.canceled_by_request'),
  i18n.t('enums.denied'),
  i18n.t('enums.canceled_by_defaulter'),
  i18n.t('enums.canceled_by_charge_back'),
  i18n.t('enums.renew_failed'),
  i18n.t('enums.renew_in_progress'),
  i18n.t('enums.defaulter_external'),
]);
